import styled, { css } from 'styled-components'

export const TerminalWrapper = styled.div`
  text-align: center;
  h1 {
    margin-bottom: 3rem;
  }
  p {
    font-size: 1.5rem;
  }
`

export const TerminalLoader = styled.div`
  margin: 3rem 0;
  display: flex;
  align-content: center;
  justify-content: center;

  opacity: 0;

  ${props =>
    props.show &&
    css`
      opacity: 1;
    `};
`

export const TerminalActions = styled.div`
  display: flex;
  gap: 1rem;
  justify-content: center;
  margin-top: 3rem;
`
